export default class RecommendedArticles {
  static get toolbox() {
    return {
      title: 'おすすめ記事',
      icon:
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="ce-popover-item__custom-icon-image"><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" /></svg>',
    }
  }

  render() {
    const wrapper = document.createElement('div')
    wrapper.classList.add('cdx-recommend-articles')

    const article = `
      <div class="cdx-recommend-articles__article">
        <div class="cdx-recommend-articles__article-image">
          <div class="cdx-recommend-articles__skeleton-image"></div>
        </div>
        <div class="cdx-recommend-articles__article-text">
          <div class="cdx-recommend-articles__article-data">
            <span class="cdx-recommend-articles__skeleton-text cdx-recommend-articles__skeleton-text--short"></span>
          </div>
          <h3 class="cdx-recommend-articles__article-title">
            <span class="cdx-recommend-articles__skeleton-text"></span>
            <span class="cdx-recommend-articles__skeleton-text"></span>
          </h3>
        </div>
      </div>
    `

    wrapper.innerHTML = `
      <h2 class="cdx-recommend-articles__header">こちらもおすすめ</h2>
      <ul class="cdx-recommend-articles__list">
        <li>${article}</li>
        <li>${article}</li>
      </ul>
    `

    return wrapper
  }

  save(blockContent) {
    return {}
  }
}
